var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFAQForm',{attrs:{"faqObject":_vm.faq,"formActionName":"تعديل السؤال"},on:{"faqSubmitted":function (submittedFaq) { return _vm.sendFaqData(submittedFaq); }}})}
var staticRenderFns = []

export { render, staticRenderFns }